import { Component, OnInit } from '@angular/core';
import { JwtRequestService } from '../../../jwt-request.service';

declare var XLSX: any;

@Component({
  selector: 'app-titulacion-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit {

  // Variables globales para paginación y búsqueda
  buscar: boolean = false;
  valor: string = '';
  pagina: number = 0;
  limite: number = 25;
  columna: string = "id";

  // Variables del componente
  campo_buscar: string = '';
  tramitesLista: any[] = [];
  isLoading: boolean = false;
  showLoadingOverlay: boolean = false;
  
  // Variables para modales
  showXmlModal: boolean = false;
  xmlContent: string = '';
  itemSeleccionado: any = null;

  // Modal para detalle del Anexo 8
  showAnexoModal: boolean = false;
  anexoDetalle: any = null;
  programasPeriodos: any[] = [];

  // Modal para alumnos
  showAlumnosModal: boolean = false;
  alumnosData: any[] = [];
  modalAlumnosTitle: string = '';
  programaSeleccionado: any = null;

  constructor(private jwtRequest: JwtRequestService) {}

  ngOnInit(): void {
    this.campo_buscar = '';
    this.cargarTramitesInicial();
  }

  // Carga inicial de trámites
  cargarTramitesInicial(): void {
    this.buscar = false;
    this.valor = '';
    this.pagina = 0;
    this.limite = 25;
    this.obtenerTramites();
  }

  // Función para buscar trámites
  buscarTramites(): void {
    if (this.campo_buscar && this.campo_buscar.trim()) {
      this.buscar = true;
      this.valor = this.campo_buscar.trim();
      this.pagina = 0;
    } else {
      this.buscar = false;
      this.valor = '';
      this.pagina = 0;
    }
    this.obtenerTramites();
  }

  // Función para actualizar listado
  actualizarListado(): void {
    if (this.campo_buscar && this.campo_buscar.trim()) {
      this.buscar = true;
      this.valor = this.campo_buscar.trim();
    } else {
      this.buscar = false;
      this.valor = '';
    }
    this.pagina = 0;
    this.obtenerTramites();
  }

  // Obtener trámites desde la API
  obtenerTramites(): void {
    this.isLoading = true;
    this.showLoadingOverlay = true;

    const queryParams = new URLSearchParams();
    queryParams.append('buscar', this.buscar.toString());
    queryParams.append('valor', this.valor);
    queryParams.append('pagina', this.pagina.toString());
    queryParams.append('limite', this.limite.toString());
    queryParams.append('columna', this.columna.toString());

    const url = `anexo-ocho?${queryParams.toString()}`;
    
    console.log('URL completa:', url);

    this.jwtRequest.get(url)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            this.tramitesLista = response.data || [];
          } else {
            console.error('Error al cargar trámites:', response.messages);
            this.tramitesLista = [];
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          console.error('Error de conexión:', error);
          this.tramitesLista = [];
        }
      });
  }

  // Abrir modal de detalle del Anexo 8
  abrirModalAnexo(item: any): void {
    this.itemSeleccionado = item;
    this.isLoading = true;
    this.showLoadingOverlay = true;

    const url = `anexo-ocho/${item.id}`;
    
    this.jwtRequest.get(url)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200 && response.data) {
            this.anexoDetalle = response.data;
            this.programasPeriodos = response.data.programas_periodos || [];
            this.showAnexoModal = true;
          } else {
            console.error('Error al cargar detalle:', response.messages);
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          console.error('Error de conexión:', error);
        }
      });
  }

  // Cerrar modal de anexo
  cerrarModalAnexo(): void {
    this.showAnexoModal = false;
    this.anexoDetalle = null;
    this.programasPeriodos = [];
    this.itemSeleccionado = null;
  }

  // Abrir modal de alumnos
  abrirModalAlumnos(programa: any): void {
    this.programaSeleccionado = programa;
    this.modalAlumnosTitle = `${programa.programa_academico || 'N/A'} | ${programa.periodo || 'N/A'}`;
    
    this.isLoading = true;
    this.showLoadingOverlay = true;
    
    setTimeout(() => {
      this.alumnosData = programa.anexos_programas_alumnos || [];
      
      this.isLoading = false;
      this.showLoadingOverlay = false;
      this.showAlumnosModal = true;
    }, 500);
  }

  // Cerrar modal de alumnos
  cerrarModalAlumnos(): void {
    this.showAlumnosModal = false;
    this.alumnosData = [];
    this.programaSeleccionado = null;
    this.modalAlumnosTitle = '';
  }

  // Exportar a Excel alumnos del programa
  exportarExcelAlumnos(): void {
    if (!this.programaSeleccionado || this.alumnosData.length === 0) {
      return;
    }

    console.log('Exportar Excel para programa:', this.programaSeleccionado);

    const worksheetData: any[] = [];

    this.alumnosData.forEach((alumno, index) => {
      worksheetData.push({
        '#': index + 1,
        'Estatus': alumno.estatus || 'N/A',
        'Año del ciclo escolar': alumno.anio_ciclo_escolar || 'N/A',
        'Nombre del alumno': alumno.nombre_alumno || 'N/A',
        'Primer Apellido': alumno.primer_apellido || 'N/A',
        'Segundo Apellido': alumno.segundo_apellido || 'N/A',
        'Género': alumno.genero || 'N/D',
        'CURP': alumno.curp || 'N/A',
        'Fecha de Nacimiento': alumno.fecha_nacimiento || 'N/A',
        'País de Nacimiento': alumno.pais_nacimiento || 'N/A',
        'Entidad Federativa o Ciudad de Nacimiento': alumno.entidad_federativa || 'N/A',
        'País de Procedencia': alumno.pais_procedencia || 'N/A',
        'Idioma/Lengua': alumno.idioma || 'N/A',
        'Necesidad Educativa Especial': alumno.necesidad_educativa_especial || 'N/A',
        'Presenta Antecedente Académico': alumno.presenta_antecedente_academico || 'N/A',
        'CCT': alumno.cct || 'N/A',
        'Matrícula Institucional': alumno.matricula_institucional || 'N/A',
        'Nivel Educativo': alumno.nivel_educativo || 'N/A',
        'Clave de la Institución': alumno.clave_institucion || 'N/A',
        'Clave de Carrera': alumno.clave_carrera || 'N/A',
        'Turno': alumno.turno || 'N/A',
        'Número de Acuerdo de RVOE': alumno.numero_acuerdo_rvoe || 'N/A',
        'Fecha de Acuerdo de RVOE': alumno.fecha_acuerdo_rvoe || 'N/A',
        'Modalidad Educativa': alumno.modalidad_educativa || 'N/A'
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      
    const columnWidths = Object.keys(worksheetData[0]).map(key => {
      const maxLength = worksheetData.reduce((max, row) => {
        const val = row[key] ? row[key].toString() : '';
        return Math.max(max, val.length);
      }, key.length);
      return { wch: Math.min(maxLength + 2, 50) };
    });
      
    worksheet['!cols'] = columnWidths;
      
    const workbook = XLSX.utils.book_new();
    const sheetName = `${this.programaSeleccionado.programa_academico || 'Programa'}_${this.programaSeleccionado.periodo || 'Periodo'}`.substring(0, 30);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    
    const fileName = `ALUMNOS_${this.programaSeleccionado.programa_academico || 'Programa'}_${this.programaSeleccionado.periodo || 'Periodo'}.xlsx`.replace(/[^a-zA-Z0-9_\-\.]/g, '_');
    XLSX.writeFile(workbook, fileName);
  }

  // Función auxiliar para formatear estatus
  getEstatusClass(estatus: string): string {
    if (estatus === '1' || estatus === 'Procesado') {
      return 'estatus-procesado';
    }
    return 'estatus-normal';
  }

  private scrollToTop(): void {
    setTimeout(() => {
      const contentScrollable = document.querySelector('.content-scrollable');
      if (contentScrollable) {
        contentScrollable.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 100);
  }
}